import { createActionNamespace } from 'Modules/core/redux';

import { MessagingQueueTypes, ShowModalPayload, ShowNotificationPayload, UpdateModalProps } from './types';
import { MESSAGING_KEY } from '../constants';


const messagingAction = createActionNamespace(MESSAGING_KEY);

export const messagingActions = {
    showNotification: messagingAction<ShowNotificationPayload>('SHOW_NOTIFICATION'),
    showModal: messagingAction<ShowModalPayload>('SHOW_MODAL'),
    updateModalProps: messagingAction<UpdateModalProps>('UPDATE_MODAL_PROPS'),
    hideMessage: messagingAction<number>('HIDE_MESSAGE'),
    closeAll: messagingAction<void>('CLOSE_ALL_MODAL'),
    enqueue: messagingAction<MessagingQueueTypes>('ENQUEUE_MESSAGE'),
};
